// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.amount-input[data-v-d52f4e24] {\n    height: 30px;\n}\n.is-table-invalid[data-v-d52f4e24] {\n    border: 1px solid red;\n    border-radius: 4px;\n}\n.form-control.is-invalid[data-v-d52f4e24],\n.form-control.is-valid[data-v-d52f4e24] {\n    background-image: none;\n    padding-right: 0.3rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
